export default {
  title: '{{company}} atualizou a sua hora de levantamento',
  new_time_label: 'Nova hora',
};
